module.exports = __webpack_public_path__ + "static/media/silo.d902af34.svg";